import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { getAuth, onAuthStateChanged } from 'firebase/auth'
import firebase from 'firebase/compat/app'

Vue.config.productionTip = false

// https://bootstrap-vue.org/docs
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

// https://vuefire.vuejs.org/vuefire/getting-started.html
import { firestorePlugin } from 'vuefire'
Vue.use(firestorePlugin)

// https://vue-meta.nuxtjs.org/guide/#download-cdn
import VueMeta from 'vue-meta'
Vue.use(VueMeta)

if (firebase.apps.length === 0) {
  firebase.initializeApp({
    apiKey: 'AIzaSyA4Thcdb4D4QvRT33qGNlY8qYw_HrfG964',
    authDomain: 'rand-boats.firebaseapp.com',
    projectId: 'rand-boats',
    storageBucket: 'rand-boats.appspot.com',
    messagingSenderId: '650557369570',
    appId: '1:650557369570:web:de80f53ed1c2efaf2402bb',
  })

  firebase.firestore().settings({
    experimentalForceLongPolling: true,
  })

  console.log('experimentalForceLongPolling')
}

let app
const unsubscribe = onAuthStateChanged(getAuth(), (user) => {
  unsubscribe()
  if (!app) {
    console.log('USER:', user)
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app')
  }
})
